import React, { Suspense } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import useComposerKeyboardHeight from '@/hooks/useComposerKeyboardHeight';
import { useVoiceModeStore } from '@/store';

const LazyVoiceModeOverlay = React.lazy(() =>
  import('@/components/VoiceMode/VoiceModeOverlay')
);

function IOSVoiceFrame({ children }) {
  const insets = useSafeAreaInsets();
  const keyboardHeight = useComposerKeyboardHeight();
  // Absolute children do not honor the app root's padding. Give every voice
  // surface the same usable bounds as the composer, including after a fold.
  return <View testID="ios-voice-frame" pointerEvents="box-none"
    style={[StyleSheet.absoluteFill, { left: insets.left, right: insets.right, bottom: keyboardHeight }]}>
    {children}
  </View>;
}

/**
 * Lazy-mount shell for VoiceModeOverlay (~1.6k lines + voice/WebRTC stack).
 * Mounted only in `(app)` layouts — voice mode is never used on marketing pages (3.1.h).
 */
export default function VoiceModeOverlayHost() {
  const isActive = useVoiceModeStore((state) => state.isActive);

  if (!isActive) return null;

  const overlay = (
    <Suspense fallback={null}>
      <LazyVoiceModeOverlay />
    </Suspense>
  );
  return Platform.OS === 'ios' ? <IOSVoiceFrame>{overlay}</IOSVoiceFrame> : overlay;
}
